export default __webpack_public_path__ + "static/media/kiss_the_rail_lowdef.f83616ab.png";